import styled from "styled-components";
import { isMobile } from "../../../common/utils";

export const LoginEmailFooter = styled.footer`
  margin-top: 32px;
  display: flex;
  align-items: start;
  justify-content: ${isMobile ? 'center' : 'flex-end'};
  height: 58px;
`;
